module.exports = "/static/assets/89813a82ff019dc1568e382b05a9a216.svg";